import CompanySwitcher from './CompanySwitcher';
import BrowserView from 'app/shared-components/util/BrowserView';
import UserMenu from './app-header/UserMenu';
import theme from 'app/theme';
import { fileAccessService } from 'app/services/fileAccess.service';
import { Menu, MenuOpen } from '@mui/icons-material';
import { captureException } from '@sentry/react';
import { selectUserCompanies } from 'app/store/userCompaniesSlice';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'app/store';
import { AppBar, Box, IconButton, Toolbar } from '@mui/material';
import { toggleDrawer, useNavigationState } from 'app/store/navigationSlice';
import { ReactComponent as SpeedchainLogo } from 'assets/White-SpeedChain-Logo.svg';
import { determineEnvironment } from 'app/pages/onboard/utils';
import { useLocation } from 'react-router-dom';

function AppHeader(): JSX.Element | null {
  const environment = determineEnvironment();
  const dispatch = useAppDispatch();
  const { selectedPaidol: paidol } = useAppSelector(selectUserCompanies);
  const { drawerOpen } = useNavigationState();
  const location = useLocation();

  const [logoUrl, setLogoUrl] = useState<string | undefined>(undefined);
  const getLogo = async (logo: string): Promise<string | undefined> => {
    try {
      return await fileAccessService.getDownloadUrl(logo);
    } catch (error) {
      captureException(error);
      return undefined;
    }
  };

  useEffect(() => {
    if (paidol?.logoUrl) {
      getLogo(paidol.logoUrl).then((url) => setLogoUrl(url));
    }
  }, [paidol?.logoUrl]);

  // Hide header for mobile demo page
  const isMobileDemoRoute = location.pathname === '/mobile-demo';

  if (isMobileDemoRoute) {
    return null;
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        background: `linear-gradient(to right, ${theme.palette.primary.darker} 0%, ${theme.palette.primary.main} 100%)`,
        top: environment === 'production' ? 0 : 30,
      }}
    >
      <Toolbar disableGutters sx={{ px: { xs: 1, md: 2 } }}>
        <IconButton color="inherit" aria-label="menu" sx={{ mr: 4 }} onClick={() => dispatch(toggleDrawer())}>
          {drawerOpen ? <MenuOpen /> : <Menu />}
        </IconButton>
        <Box sx={{ mr: 1, flexGrow: 1, display: 'flex' }}>
          {logoUrl ? <CustomLogo logoUrl={logoUrl} /> : <SpeedchainLogo />}
        </Box>
        <BrowserView>
          <CompanySwitcher sx={{ mr: 2, minWidth: 256 }} />
          <UserMenu />
        </BrowserView>
      </Toolbar>
    </AppBar>
  );
}

const CustomLogo = ({ logoUrl }: { logoUrl: string }) => {
  return (
    <Box
      component="img"
      src={logoUrl}
      alt="Custom Company Logo"
      sx={{
        maxWidth: 200,
        maxHeight: 40,
      }}
    />
  );
};

export default AppHeader;
